import React from 'react'

function Message({text}:{text:string}) {
  return (
    <h3 className="message">
     {text} 
    </h3>
  )
}

export default Message
